import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "31px",
    height: "31px",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "31px",
    padding: ".25rem .5rem",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "31px",
  }),
};

const SubProduct = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [productDrp, setProductDrpData] = useState([]);
  const [formData, setFormData] = useState({
    product_id: "",
  });

  const getSubProduct = () => {
    setLoading(true);
    axios
      .post(API_URL.SUB_PRODUCT_LIST, {
        product_id: formData.product_id,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data.data);
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,
            position: "top-right",
          });
        }
      );
  };

  const getProductDrpData = () => {
    axios.post(API_URL.PRODUCT_HAS_SUB_LIST, {}).then((res) => {
      setProductDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setProductDrpData(cd);
    });
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = productData.filter((r) => r.id != row.id);
              setProductData(newData);
              toast.success(row.name + " Delete Successfully", {
                autoClose: 3000,
                position: "top-right",
              });
            } else {
              toast.error(res.data.data, {
                autoClose: 3000,
                position: "top-right",
              });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getSubProduct();
    getProductDrpData();
  }, []);

  useEffect(() => {
    getSubProduct();
  }, [formData.product_id]);

  return (
    <>
      <div className="page-header">
        <div className="d-flex align-items-center content-page-header">
          <div className="d-flex align-items-center ">
            <h5 className="me-1">Sub Product </h5>
            <small className="me-2"> ({productData.length})</small>
            <div className="d-flex">
              <div className="col-md-12">
                <div className="form-group mb-0" style={{ width: "250px" }}>
                  <Select
                    placeholder="Select Product"
                    options={productDrp}
                    isClearable={true}
                    value={productDrp.find(
                      (r) => r.value == formData.product_id
                    )}
                    styles={customStyles}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        product_id: e?.value ? e.value : null,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/subproduct/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Sub Product
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "10%" }}>Image</th>
                        <th style={{ width: "20%" }}>Name</th>
                        <th style={{ width: "20%" }}>Product</th>
                        <th style={{ width: "20%" }}>Size</th>
                        <th style={{ width: "15%" }}>Weight</th>
                        <th style={{ width: "10%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td className="table-avatar">
                              <div
                                style={{
                                  height: 50,
                                  width: 50,
                                  backgroundSize: "cover",
                                  backgroundImage: "url(" + row.image + ")",
                                }}
                              ></div>
                            </td>
                            <td>{row.name}</td>
                            <td>{row.product_name}</td>
                            <td>{row.size_name}</td>
                            <td>{row.weight}</td>
                            <td className="d-flex justify-content-end gap-3">
                              <Link to={"/admin/subproduct/edit/" + row.id}>
                                <i className="fa fa-edit"></i>
                              </Link>
                              <i
                                className="fa fa-trash-alt"
                                onClick={() => deletProduct(row)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubProduct;
